import { some } from 'lodash';
// import { trackPromise } from 'react-promise-tracker';

import { CredentialType } from 'admin/credentials/Credentials';
import { SkuId } from 'admin/skus/Skus';
import { CredentialHierarchy, ReviewResponseApiType, SourceId } from 'admin/sources/Sources';
import { ResponseState } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';
import { ReplyTo, ReplyMode, ReviewProps } from 'reviews2/feed/review-yeti/Review.types';
import { PublishRequest, YetiReview } from 'reviews2/feed/Reviews.types';

interface ConvertToYetiArgs {
    context: ReviewProps;
    currentReply?: YetiReview;
    editReply?: YetiReview;
    replyTo?: ReplyTo;
    replyMode?: ReplyMode;
    response?: any; // <ResponseEditor /> result
}

export const convertToYetiResponse = ({
    context,
    editReply,
    currentReply,
    replyMode,
    response,
}: ConvertToYetiArgs): PublishRequest => {
    const { review } = context;
    const { media, text } = response;

    return {
        text,
        id: editReply?.document_id || null,
        medias: convertToYetiMedias(media),
        parentID: currentReply?.document_id || review.document_id,
        manualPublish: shouldManualPublish(review),
        reviewDate: review.post_created_at,
    };
};

export const convertToYetiMedias = (medias: any[]) => {
    if (!medias.length) {
        return null;
    }

    return medias.map((media: any) => {
        return {
            url: media.url,
            name: media.name,
            mediaType: media.isImage ? 'Photo' : 'Video',
            mimeType: media.type,
        };
    });
};

export const isPending = (reply: YetiReview) => {
    return [ResponseState.PendingApproval, ResponseState.PendingModeration].includes(reply.responseState);
};

export const isPendingPublish = (reply: YetiReview) => {
    return [ResponseState.PendingPublish, ResponseState.PendingManual].includes(reply.responseState);
};

export const shouldManualPublish = (review?: YetiReview) => {
    if (allowHealthgradesApiResponse(review)) {
        return false;
    }

    return (
        (review?.source?.oauthable &&
            review.source?.credentialHierarchy === CredentialHierarchy.Tenant &&
            some(review.credentials, { credentialType: CredentialType.Password }) &&
            !some(review.credentials, { credentialType: CredentialType.PageToken }) &&
            review.source?.review.reviewResponseConfig?.reviewResponseApiType === ReviewResponseApiType.OAuth) ||
        review.source?.review.reviewResponseConfig.reviewResponseApiType === ReviewResponseApiType.Manual
    );
};

export const allowHealthgradesApiResponse = (review: YetiReview) => {
    return (
        review.review_source_id === SourceId.HealthGrades && review.tenant?.skuIDs?.includes(SkuId.HGApiIntegration2026)
    );
};
